/* Maximus · carrusel de la portada (sin librerías). Puntos, flechas, teclado y avance automático que respeta "reducir movimiento". */
(function () {
  'use strict';
  var root = document.querySelector('[data-mxh]');
  if (!root) return;
  var track = root.querySelector('[data-mxh-track]');
  var slides = [].slice.call(track.children);
  var dotsBox = root.querySelector('[data-mxh-dots]');
  var prev = root.querySelector('[data-mxh-prev]');
  var next = root.querySelector('[data-mxh-next]');
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var index = 0, timer = null, paused = false;

  var dots = slides.map(function (s, i) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mxh__dot';
    b.setAttribute('role', 'tab');
    b.setAttribute('aria-label', 'Diapositiva ' + (i + 1) + ' de ' + slides.length);
    b.addEventListener('click', function () { go(i, true); });
    dotsBox.appendChild(b);
    return b;
  });

  function mark(i) {
    index = i;
    dots.forEach(function (d, k) { d.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
  }

  function go(i, user) {
    i = (i + slides.length) % slides.length;
    track.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    mark(i);
    if (user) stop();
  }

  var raf = null;
  track.addEventListener('scroll', function () {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = null;
      var w = track.clientWidth || 1;
      var i = Math.round(track.scrollLeft / w);
      if (i !== index && slides[i]) mark(i);
    });
  }, { passive: true });

  prev.addEventListener('click', function () { go(index - 1, true); });
  next.addEventListener('click', function () { go(index + 1, true); });
  track.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { go(index + 1, true); e.preventDefault(); }
    if (e.key === 'ArrowLeft') { go(index - 1, true); e.preventDefault(); }
  });

  function start() {
    if (reduce || timer || paused) return;
    timer = setInterval(function () { go(index + 1, false); }, 7000);
  }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  root.addEventListener('mouseenter', function () { paused = true; stop(); });
  root.addEventListener('mouseleave', function () { paused = false; });
  root.addEventListener('focusin', function () { paused = true; stop(); });
  root.addEventListener('touchstart', function () { paused = true; stop(); }, { passive: true });

  // Carga diferida de las demás diapositivas al acercarse.
  slides.forEach(function (s) { var im = s.querySelector('img'); if (im) im.loading = 'eager'; });

  mark(0);
  start();
})();
